import React, {useState, useEffect, Fragment} from 'react';
import useWindowDimensions from '../../utils/useWindowDimensions';
import classes from './ContentDetails.module.scss';
import Button from '../UI/Button/Button';
import GooglePay from '../GooglePay/GooglePay';
import axios from '../../axios-instance';
import AppleWallet from '../../images/Add_to_Apple_Wallet_rgb_US-UK.svg';
import ResponsiveDialog from '../UI/ResponsiveDialog/ResponsiveDialog';
import Scratcher from '../Scratcher/Scratcher';
import OfferDetails from './OfferDetails/OfferDetails';
// import Loader from './../UI/Loader/Loader';
import AgeGate from './../AgeGate/AgeGate';
import { useSelector } from 'react-redux';

let styles = {
    dateColor: {
        color: '#22A033'
    }
}
const ContentDetails = props => {
    const { scratcherOverlayImage } = props;
    const { height, width } = useWindowDimensions();
    const [
        // showLoading
        ,setShowLoading] = useState(true);
    const [showTerms, setShowTerms] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [downloadLink, setDownloadLink] = useState('');
    const [action, setAction] = useState('');
    const [imageError, setImageError] = useState(false)
    const [showOfferDetails, setShowOfferDetails] = useState(false);
    const [hasTimer, setHasTimer] = useState(false);
    const [limitSeconds, setLimitSeconds] = useState(0);
    const [hideAt, setHideAt] = useState(0);
    const [running, setRunning] = useState(false);
    const [expDate, setExpDate] = useState(0);
    const [expired, setExpired] = useState(null);
    const [distance, setDistance] = useState(0);
    const [showAgeGate, setShowAgeGate] = useState(false);
    const [showActionButtons, setShowActionButtons] = useState(true);
    const [autoAccept, setAutoAccept] = useState(false);

    const content = useSelector((state) => state.content);
    const device = useSelector((state) => state.device);

    const getWindowDimensions = () => {
        let div = document.getElementById('responsiveContentContainer');    
        if (div) {
            let w = div.offsetWidth;
            let h = div.offsetHeight
            return {
                w,
                h
            };
        }
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    let attachedClasses = [classes.ContentPreview, classes.Close];

    let actionClasses = [classes.Actions];

    const udateTerms = (bool) =>  {
        setShowTerms(bool)
    }

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if(content?.content?.age_gate_enabled) {
            setShowAgeGate(true);
        } 
        
        // Check tags
        for(const element of content?.content?.tags) {                
            if(element.name === 'no-action-buttons') {
                setShowActionButtons(false)
            }
            if(element.name === 'auto-save') {
                setAutoAccept(true);
            }
        }

        setHasTimer(content?.content?.redemption?.timer?.enabled ?? false);
        setLimitSeconds(content?.content?.redemption?.timer?.limit ?? 0);
        setHideAt(Number(content?.content?.redemption?.status?.hide_at) * 1000 ?? 0);
    }, [content]);

    useEffect(()=> {
        let countInterval;
        if (running) {
            const countDownDate = new Date(expDate).getTime();
            countInterval = setInterval(() => {
                const now = new Date().getTime();
                const distance = countDownDate - now;
                setDistance(distance)
                if (distance < 0) {
                    setExpired(true);
                    clearInterval(countInterval);
                } else {
                    setExpired(false)
                }
            }, 1000);
            return () =>  {
                setRunning(false);
                setExpDate(0)
                clearInterval(countInterval);
            }
        } else {
            setRunning(false);
            setExpDate(0)
            clearInterval(countInterval);
        }
    }, [expDate, running])

    const createMarkup = () => {
        return {__html: content?.content?.description};
    }

    useEffect(() => {
        udateTerms(content?.hasTerms)
    }, [content?.hasTerms]) 

    useEffect(() => {
        updatePass(content?.androidPass)
    }, [content?.androidPass]) 

    useEffect(() => {
        if (content?.showDownload) {
            let urlArr = new URL(content?.buyOnline).search.split('&');
            let str = urlArr[0].split('?action=').join('')
            setAction(str.charAt(0).toUpperCase() + str.slice(1))
            if (device?.deviceDetails?.isMobile) {
                device?.deviceDetails?.isIphone ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')));
            } else {
                device?.deviceDetails?.os_name === "Mac OS" ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')))
            }
        }
    }, [content?.showDownload, content?.buyOnline, device?.deviceDetails]) 

    useEffect(() => {
        // If the auto-save tag is added to the content, an "accept" impression is added immediately so that the prize can be reserved. 
        if(autoAccept) {
            updateStatus(2);
        }        

        if (props.scratcher === true || props.scratcher === null) {
            toggleLoading(true);
        } else {
            // Delay the update by 2 seconds to avoid collision with catch impression tracking
            setTimeout(()=>{
                updateStatus(1);
            }, 2000);
            //toggleLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.scratcher, autoAccept]) 

    const updatePass = (bool) =>{
        setShowPass(true)
    }

    const toggleLoading = (bool) => {
        setShowLoading(bool);
    }

    const onTerms = () => {
        setShowModal(!showModal)
    }
    
    // eslint-disable-next-line no-undef
    const updateStatus = async status => {
        try {
          const uri = `/device/${device?.deviceDetails?.uuid}/content/${content?.content?.id}?status=${status}`;
          await axios.put(
            uri,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }
            }
          ).then((res) => {
            if (res && res.status === 200) {
                if (res.data && res.data.message) {
                //   console.log('STATUS: ', status + ' ', res.data.message);
                }
              }
          });
        } catch (err) {
            console.error('Error: ', err);
        }
    };    

    const postEvent = async(event) => {

        try {
          await axios.post(`/event`, event, {
            headers: {
              'x-device-uuid': `${device?.deviceDetails?.uuid}`,
            }
          }).then((res) => {
            if (res && res.data) {
                console.log('Event tracked', res.data);
              }
          });

        } catch(err) {
          console.error('Error: ', err);
        }
    }

    const getAppleWalletPasskit = async () => {
        let root = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_ROOT_DEV : process.env.REACT_APP_ACTV8_API_ROOT_PROD;
        let key = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_KEY_DEV : process.env.REACT_APP_ACTV8_API_KEY_PROD;

        try {
          const uri = `${root}/device/${device?.deviceDetails?.id}/content/${content?.content?.id}/applepass`;
          fetch(uri, {
            headers: {
              'x-api-key': `${key}`,
              'x-api-version': `4.4`,
              'Accept': 'application/vnd.apple.pkpass',
              'x-device-uuid': `${device?.deviceDetails?.uuid}`
            }
          }).then(response => {            
            updateStatus(2);
            response.blob().then(blob => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.href = url;
              a.download = 'pass.pkpass';
              a.click();
            });
          });
        } catch (err) {
          console.error('Error: ', err);
        }
    };

    const createAppleWalletPasskit = async () => {
        try {
          const uri = `/device/${device?.deviceDetails?.id}/content/${content?.id}/applepass`;
          const res = await axios.post(
            uri,
            {"forward_params":props.forwardParams},
            {
              headers: {
                'Accept': 'application/vnd.apple.pkpass',
                'x-device-uuid': `${device?.deviceDetails?.uuid}`
              }
            }
          );
          if (res && res.data) {
            getAppleWalletPasskit();
          }
        } catch (err) {
          console.error(err);
        }
    };

    const onBuyNow = () => {
        let url = content?.content?.redemption?.url ?? '';
        // Appends forward params (i.e. macros) based on env setting 
        if(url !== '' && process.env.REACT_APP_FORWARD_PARAMS === 'true') {
            url += url.indexOf('?') > -1 ? '&' : '?';
            url += props.forwardParams;
        }
        window.open(url,'_blank');
        updateStatus(5)
    }

    const onClickThrough1 = () => {
        let url = content?.clickThroughBtn1?.value ?? '';
        handleClickThrough(url);
    }

    const onClickThrough2 = () => {
        let url = content?.clickThroughBtn2?.value ?? '';
        handleClickThrough(url);
    }

    const handleClickThrough = (url, target = '_blank') => {
        const event = {
            category: "End-User Action",
            subcategory: "Content Button",
            action: "Click-Through",
            label: url,
        } 

        event.client_id = content?.content?.client_id ?? null;
        event.campaign_id = content?.content?.pivot?.campaign_id ?? null;
        event.trigger_id = content?.content?.pivot?.trigger_id ?? null;
        event.content_id = content?.content?.pivot?.content_id ?? null;

        updateStatus(8)
        postEvent(event);
        window.open(url, target);

    }

    const onDownloadApp = () => {
        window.open(downloadLink, "_blank")
    }
    const onImageError = () => {
        setImageError(true);
        toggleLoading(false);
    }
    const onViewOfferDetails = (type) => {
        setShowOfferDetails(true);
        if (type === 'instore' && !hasTimer) {
            updateStatus(4)
        }
    }
    const onCloseOfferDetails = () => {
        setShowOfferDetails(!showOfferDetails);
    }
    if (content?.content?.redemption?.method === 3) {
        actionClasses.push(classes.MoreBtnSpace)
    }
    let terms;

    if (props.open) {
        attachedClasses = [classes.ContentPreview, classes.Open];
    }
    if (content?.hasTerms || showTerms) {
        terms = (
            <div className={classes.Terms} onClick={onTerms}>
                Terms & Conditions
            </div>
        )
    }
    if (content?.endDate) {
        let date = content?.endDate.split(' ');
        styles = {
            dateColor: {
                color: props.date === 'Expired' ? '#A02222' : (date[0] === 'in' && Number(date[1]) <= 3 && date[2] === 'days') || date[2] === 'day' ? '#FFA000' : '#22A033'
            }
        }
    }
   
    const [showApplePass, setShowApplePass] = useState(false);
    const [showGooglePass, setShowGooglePass] = useState(false);

    useEffect(() => {
        if (showPass === true) {
            var winNav = window.navigator;
            let isIOSChrome = winNav.userAgent.match('CriOS');
            if (
                device?.deviceDetails?.isMobile &&
                device?.deviceDetails?.isIphone &&
                content?.applePass &&
                !isIOSChrome
            ) {
                setShowApplePass(true);
            } else {
                setShowGooglePass(true);
            }
        }
    }, [
        content,
        content?.applePass,
        device,
        device?.isIphone,
        device?.isMobile,
        showPass,
    ]);

    const handleAgeEntered = (isLegal) => {
        setShowAgeGate(!isLegal);
    }

    const urls = content?.content?.urls ? content?.content?.urls?.map((url) => 
        <Button 
            className={classes.Button} 
            href={url.url} 
            key={url.url}
            target={url.target?? '_self'}
            onClick={() => handleClickThrough(url.url, url.target?? '_self')}
            btnText={url.label}/>
    ) : null;
    
    const urlActionButtons = (
    <div className={actionClasses.join(' ')} style={{position:'inherit'}}>
        {urls?.length > 0 && urls} 
        {content?.content?.url && 
            <Button         
                className={classes.Button} 
                href={content?.content?.url} 
                target="_blank"
                onClick={() => handleClickThrough(content?.content?.url)}
                btnText="Click Here"
            />
        }
    </div>
    )

    const genericActionButtons = (
        <div className={actionClasses.join(' ')}>
            {(content?.content?.redemption?.method === 2 ||
                content?.content?.redemption?.method === 3) && (
                <Button
                    onClick={() => onViewOfferDetails('instore')}
                    btnText={
                        content?.content?.type === 'prize'
                            ? 'Redeem Prize'
                            : content?.buyInStoreText
                    }
                    className={classes.Button}
                />
            )}
            {content?.buyOnline &&
            content?.buyOnline !== '' &&
            content?.type !== 'prize' &&
            !content?.showDownload &&
            !content?.clickThroughBtn1 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.content?.redemption &&
                        content?.content?.redemption !== null &&
                        content?.content?.redemption.url
                            ? content?.content?.redemption.url
                            : ''
                    }
                    target='_blank'
                    onClick={onBuyNow}
                    btnText={content?.buyNowText}></Button>
            ) : (
                ''
            )}

            {content?.clickThroughBtn1 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.clickThroughBtn1.value
                            ? content?.clickThroughBtn1.value
                            : ''
                    }
                    target='_blank'
                    onClick={onClickThrough1}
                    btnText={
                        content?.clickThroughBtn1.label
                            ? content?.clickThroughBtn1.label
                            : ''
                    }></Button>
            ) : (
                ''
            )}

            {content?.clickThroughBtn2 ? (
                <Button
                    className={classes.Button}
                    href={
                        content?.clickThroughBtn2.value
                            ? content?.clickThroughBtn2.value
                            : ''
                    }
                    target='_blank'
                    onClick={onClickThrough2}
                    btnText={
                        content?.clickThroughBtn2?.label
                            ? content?.clickThroughBtn2?.label
                            : ''
                    }></Button>
            ) : (
                ''
            )}

            {content?.showDownload && downloadLink && downloadLink !== '' ? (
                <Button
                    href={downloadLink}
                    target='_blank'
                    className={classes.Button}
                    btnText={action}
                    onClick={onDownloadApp}></Button>
            ) : (
                ''
            )}
        </div>
    );

    const actionButtons = (
        <div>{content?.content?.type === 'url' || content?.content?.type === 'message' ? urlActionButtons : genericActionButtons}</div>
    )

    const offerComp = (
        <div
            className={classes.ContentContainer}
            id={'responsiveContentContainer'}>
            <ResponsiveDialog open={showModal} onClose={() => onTerms()}>
                {content?.terms}
            </ResponsiveDialog>
            <ResponsiveDialog
                offerDetailsModal={true}
                open={showOfferDetails}
                onClose={() => onCloseOfferDetails()}>
                <OfferDetails
                    onUpdateStatus={updateStatus}
                    brand={content?.brand}
                    content={content?.content}
                    hasTimer={hasTimer}
                    hideAt={hideAt}
                    limitSeconds={limitSeconds}
                    onSetExpDate={(date) => setExpDate(date)}
                    distance={distance}
                    running={running}
                    onSetRunning={(bool) => setRunning(bool)}
                    expired={expired}
                    onClose={() => onCloseOfferDetails()}
                    onBuyNow={onBuyNow}
                />
            </ResponsiveDialog>
            <div>
                <section className={classes.HeroContainer}>
                    {imageError ? (
                        <div className={classes.FallbackHero}>
                            <div>Image Loading Error</div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.HeroImage}>
                        {!imageError ? (
                            <img
                                src={content?.hero}
                                alt={content?.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </section>
                {showAgeGate ? (
                    <Fragment>
                        <div
                            className={classes.ContentItems}
                            style={{
                                width: '312px',
                                height: '320px',
                                borderRadius: '12px',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)',
                                margin: '0 auto 15px auto',
                            }}>
                            <AgeGate onAgeEntered={handleAgeEntered} />
                        </div>
                    </Fragment>
                ) : (
                    <div className={classes.ContentItems}>
                        <div className={classes.Title}>{content?.title}</div>
                        <div className={classes.SubContent}>
                            <div className={classes.Brand}>
                                From {content?.brand}
                            </div>
                            <div
                                style={styles.dateColor}
                                className={classes.Date}>
                                {content?.endDate !== 'Expired'
                                    ? 'Expires'
                                    : ''}{' '}
                                {content?.endDate}
                            </div>
                            <div className={classes.PayBtn}>
                                <div className={classes.BtnCol}>
                                    {showApplePass === true && content?.content?.id && (
                                        <img
                                            src={AppleWallet}
                                            alt='Add to Apple Wallet'
                                            className={classes.WalletButton}
                                            onClick={() =>
                                                createAppleWalletPasskit()
                                            }
                                        />
                                    )}
                                    {showGooglePass && content?.jwt && content?.jwt !== '' && (
                                        <GooglePay
                                            onSaveToWallet={() =>
                                                updateStatus(2)
                                            }
                                            jwt={content?.jwt}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={classes.Description}>
                            <div dangerouslySetInnerHTML={createMarkup()}></div>
                            {terms}
                        </div>
                    </div>
                )}
            </div>

            {!showAgeGate && showActionButtons && actionButtons}
        </div>
    );

    const prizeComp = offerComp;

    const urlComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'}>
        <ResponsiveDialog
            open={showModal}
            onClose={() => onTerms()}>
                {content?.terms}
        </ResponsiveDialog>
        <div>
            <section className={classes.HeroContainer}>
                { imageError ? <div className={classes.FallbackHero}><div>Image Loading Error</div></div> : ''}
                <div className={classes.HeroImage}>
                    { !imageError ?
                        <img
                            src={content?.hero}
                            alt={content?.hero}
                            onLoad={() => toggleLoading(false)}
                            onError={onImageError}/> : ''
                    }                            
                </div>
            </section>
            { showAgeGate ? 
                <Fragment>
                    <div className={classes.ContentItems} style={{width: '312px', height : '320px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)', margin: '0 auto 15px auto'}}>
                        <AgeGate onAgeEntered={handleAgeEntered}/>
                    </div> 
                </Fragment> 
                : ''
            }

        </div>
        
        { !showAgeGate && showActionButtons && actionButtons}
    </div>)

    const messageComp = (<div className={classes.ContentContainer} id={'responsiveContentContainer'}>
        <ResponsiveDialog
            open={showModal}
            onClose={() => onTerms()}>
                {content?.terms}
        </ResponsiveDialog>
        <div>
            <section className={classes.HeroContainer}>
                { imageError ? <div className={classes.FallbackHero}><div>Image Loading Error</div></div> : ''}
                <div className={classes.HeroImage}>
                    { !imageError ?
                        <img
                            src={content?.hero}
                            alt={content?.hero}
                            onLoad={() => toggleLoading(false)}
                            onError={onImageError}/> : ''
                    }                            
                </div>
            </section>
            {content?.content?.images?.in_body?.url ? 
                <section className={classes.InBodyContainer}>
                    <div className={classes.InBodyImage}>
                        <img
                            src={content?.content?.images.in_body.url}
                            alt={content?.content?.images.in_body.url}/> 
                    </div>
                </section> : ''}            
            { showAgeGate ? 
                <Fragment>
                    <div className={classes.ContentItems} style={{width: '312px', height : '320px', borderRadius: '12px', backgroundColor: '#FFFFFF', boxShadow: '0 4px 10px 0 rgba(0,0,0,0.25)', margin: '0 auto 15px auto'}}>
                        <AgeGate onAgeEntered={handleAgeEntered}/>
                    </div> 
                </Fragment> 
                : ''
            }

        </div>
        
        { !showAgeGate && showActionButtons && actionButtons}
    </div>)

    let contentComp = null;
    switch (content?.content?.type) {
        case 'offer': contentComp = offerComp; break;
        case 'url': contentComp = urlComp; break;
        case 'message': contentComp = messageComp; break;
        case 'prize': contentComp = prizeComp; break;
        default:
    }

    return (
        <div
            className={attachedClasses.join(' ')}
            style={{ maxHeight: '736px' }}>
            {/* {showLoading ? (
                <div style={{height: height, width: width, maxHeight: '736px', maxWidth: '414px', paddingTop: '60px'}} className={classes.ContentPreviewLoading}>
                    <Loader />
                </div> ) : ''
            } */}
            {props.scratcher ? (
                <Scratcher
                    onUpdateStatus={updateStatus}
                    onToggleLoading={toggleLoading}
                    overlay={scratcherOverlayImage}
                    height={height}
                    width={width}
                    isMobile={device?.deviceDetails?.isMobile}
                    windowDimensions={windowDimensions}>
                    {contentComp}
                </Scratcher>
            ) : (
                contentComp
            )}
        </div>
    );
}

export default ContentDetails;

